import { Component, OnInit } from '@angular/core';
import { ServicesSunsetService } from '../services-sunset.service';
import Swal from 'sweetalert2';
import { Recuperar } from './recuperar.entity';

@Component({
  selector: 'app-recuperar-clave',
  templateUrl: './recuperar-clave.component.html',
  styleUrls: ['../../app.component.css']
  
})
export class RecuperarClaveComponent implements OnInit {

  correo: string;
  mensaje: string;
  recuperar: Recuperar;
  exitoso: boolean;
  btnRecuperar: boolean;
  constructor(private _servicios: ServicesSunsetService) { }

  ngOnInit(): void {

    this.correo="";
    this.mensaje = "";
    this.exitoso = false;
    this.btnRecuperar = true;
    this.recuperar = new Recuperar();
  }

  validar() {

    if (this.correo.trim() === '') {


      Swal.fire(
        'Notificación',
        'Debe especificar un correo',
        'warning'
      );

      return;


    }

    this.exitoso = false;
    this.btnRecuperar = false;

    this._servicios.obtenerIdUsuario(this.correo).subscribe(

      (data: any) => {

        if (data.ok.toString() === 'true') {

          if(data.consulta.length>0) {

            this.recuperar = new Recuperar();

            this.recuperar.de = "contactos@sunsetmanager.com";
            this.recuperar.para = this.correo;
            this.recuperar.token = data.consulta[0].id;

            this._servicios.enviarCorreoRecuperacion(this.recuperar).subscribe(
            (data: any) => {

              

              if (data.ok.toString() === 'true') {

             
                Swal.fire(
                  'Notificación',
                  'Proceso realizado con éxito',
                  'success'
                ).then((result) => {
                  if (result.value) {
              
                    this.exitoso = true;

                  
                    }}
                    ).finally( ()=> {

                      this.exitoso = true;


                    }
                      
                    );

              
              
                return 

              } else {

                  this.exitoso = false;
                  this.btnRecuperar = true;
                  this.mensaje = "Ha sucedido un error por favor intente de nuevo o más tarde"
                  return 

              }

            }
            
            )


          } else {

            this.btnRecuperar = true;
            this.mensaje = this.correo + " no está registrado en nuestros servicios"
            return 

          }


        } else {

         Swal.fire(
           'Notificación',
           data.msg,
           'warning'
         );

         return;

        }

    }

     );

  
  }

  DesactivarMensaje() {

    this.mensaje = "";

  }

}
